import { VOLUME, REDUCERS } from '../../constants.js';

const initialVolume = {
  reducer_type : REDUCERS.VOLUME,
  changingVolume : false,
  speakerVolume : 50,
  microphoneVolume : 50
};

const volumeControl = (state = initialVolume, action) => {
  state.changingVolume = false;
  switch (action.type) {
    case VOLUME.SPEAKER:
      return Object.assign({}, state, { speakerVolume: action.volume, changingVolume:true });
    case VOLUME.MICROPHONE:
      return Object.assign({}, state, { microphoneVolume: action.volume, changingVolume: true});
    default:
      return state;
  }
}

export default volumeControl;



// WEBPACK FOOTER //
// ./src/redux/reducers/reducer_volume.js